export interface QueueItem<T> {
  id?: string;
  payload: T;
}

export abstract class GenericQueue<T> {
  protected queue: QueueItem<T>[] = [];
  protected running = false;

  enqueue(item: QueueItem<T>) {
    this.queue.push(item);
    this.onEnqueue();
  }

  protected dequeue(): QueueItem<T> | undefined {
    return this.queue.shift();
  }

  protected peek(): QueueItem<T> | undefined {
    return this.queue[0];
  }

  protected abstract onEnqueue(): void;
}
